import {Component, Output, EventEmitter, OnInit, SimpleChanges, OnChanges, Input} from '@angular/core';
import { Project } from '../model/project';
import { ProjectService } from '../project/project.service';
import { Client } from '../model/client';
import { FormControl, FormGroup, Validators} from '@angular/forms';
import {FormModel} from '../model/forms/form-model';
import {Ftp} from '../model/ftp';
import {ServerConfig} from '../model/ServerConfig';
import {SmsConfig} from '../model/smsConfig';
import {FacebookAPIConfig} from '../model/FacebookAPIConfig';
import {MailConfig} from '../model/mailConfig';
import {TwitterAPIConfig} from '../model/TwitterAPIConfig';


@Component({

    selector: 'create-object-dialog',
    styles: [
        `
.modal-dialog {
    width: 50%;
    margin:  auto;
}
.modal-header{
    background-color:dodgerblue;
    color:antiquewhite;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}
.modal-content{
    border-top-right-radius: 18px;
    border-top-left-radius: 18px;
}
.closeX{color:white;size:25px;}
.btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
.btn-danger:hover{background-color: #FF2400;}
.objectIcon{ height:30px;}


 /* new css*/

.modal-title{margin-top: -5px;}
.closeBtnH4{margin-top:-5px;margin-right: -8px;}
.appWindow {
    height: 35px;
}

.tableHeader{ background-image: url("../../assets/images/blueBack.jpg");}
th{color:#ffffff;text-align: center;}

.modalBodyContainer{
  background-color:  #ECE8E5;
}

.modal-footer{background-color: #ECE8E5;border-top: groove;}
.modal-body {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}
.modal-body thead {
    position: sticky;
    top:0;
}
::-webkit-scrollbar {
    width: 14px;
    height: 5px;
    background-color: #F5F3F0;
}
::-webkit-scrollbar-thumb {
    height: 6px;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    -webkit-border-radius: 7px;
    background-color:#BACEFF;
    -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
}
::-webkit-scrollbar-button {
    width: 14px;
    height: 14px;
    display: none;
}
::-webkit-scrollbar-corner {
    background-color: transparent;
}

.modal-dialog {
  margin: 50px auto auto;
  background-color: #0064FE;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.modal-header {
  height:56px;
//background-color: #0064FE;
  background-image: url("../../assets/images/headerBack.jpg");
  color:  #ECE8E5;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.modal-content {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding-left: 3px;
  padding-right: 3px;
  background-color: #0064FE;
  padding-bottom: 3px;
}

.closeX {
    color: white;
    size: 25px;
}

.btn-outline-danger {
    background-color: #d6462e;
    border-style: solid;
    border-color: white;
    border-width: 2px;
    padding: 0;
}

/* .btn-outline-danger:hover {
     width: 32px;
     background-image: url("../../../assets/images/closeBtnHovered.png");
 }*/

.closeIcon:hover{ width: 32px;background-image: url("../../assets/images/closeBtnHovered.png");}

.modal-footer{margin-top:5%;}

.closeIcon{ width: 32px;background-image: url("../../assets/images/closeBtn.png");}`
    ],

    template: `<div *ngIf="!hide" class="modal"  style="margin : 20px; display: inline">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <!-- header-->
                        <div class="modal-header">
                            <img *ngIf="wizardTitle  === 'New Project'" class="objectIcon" src="../../assets/images/041.png">
                            <img *ngIf="wizardTitle  === 'New Client'" class="objectIcon" src="../../assets/images/184.png">
                            <img *ngIf="wizardTitle === 'Configure Server IP'" class="objectIcon" src="../../assets/images/server.png">
                            <img *ngIf="wizardTitle === 'Configure Twillio API'" class="objectIcon" src="../../assets/images/437.png">
                            <img *ngIf="wizardTitle === 'Log' && this.log" class="objectIcon" src="../../assets/images/notepad.png">
                          <h4 class="modal-title">{{wizardTitle}}</h4>
                          <!--<button (click)="toggleDialog(); newForm.reset()" type="button" class="btn btn-danger" data-dismiss="modal" aria-label="Close">
                            <span class="closeX" aria-hidden="true"><i class="fas fa-times"></i></span>
                          </button>-->
                            <h4 class="closeBtnH4"><button (click)="toggleDialog();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                                <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../assets/images/closeBtn.png"></span>
                            </button></h4>
                        </div>
                        <div class="modalBodyContainer">
                            <div class="modal-body">
                              <div class="bodyContent">
                                <div *ngIf="errorCreatingObject" class="alert alert-danger">
                                    <a href="#" class="close" data-dismiss="alert" aria-label="close" (click)="onClose()">&times;</a>
                                    <strong>Error!</strong> has <a href="#" class="alert-link">occured while creating a project.</a>.
                                </div>
                                <div *ngIf="objectCreated" class="alert alert-success">
                                    <a href="#" class="close" data-dismiss="alert" aria-label="close" (click)="onClose()">&times;</a>
                                    <strong>Success!</strong> configuration <a href="#" class="alert-link">saved</a>.
                                </div>
                                <form *ngIf="!log" novalidate accept-charset="UTF-8" name="newForm" (ngSubmit)="newForm.form.valid && createModelObject()" #newForm="ngForm">
                                    <div *ngFor="let input of this.formModel.inputs" class="row" style="margin-top:20px;">
                                        <div class="col-md-4">
                                            <label>{{input.label.get('en')}}</label>
                                        </div>
                                        <ng-container [ngSwitch]="input.type">
                                          <div *ngSwitchCase="'text'" class="col-md-8">
                                            <input type="text" [placeholder]="input.placeholder.get('en')"  [name]="input.name.get('en')" class="form-control" [(ngModel)]="input.value"/>
                                            <div class="invalid-feedback">
                                              Please provide a valid {{input.label.get('en')}}.
                                            </div>
                                            <div class="valid-feedback">
                                              Looks Good.
                                            </div>
                                          </div>
                                          <div *ngSwitchCase="'password'" class="col-md-8">
                                            <input type="password" [placeholder]="input.placeholder.get('en')"  [name]="input.name.get('en')" class="form-control" [(ngModel)]="input.value"/>
                                            <div class="invalid-feedback">
                                              Please provide a valid {{input.label.get('en')}}.
                                            </div>
                                            <div class="valid-feedback">
                                              Looks Good.
                                            </div>
                                          </div>
                                          <div *ngSwitchCase="'dropdown'" class="col-md-8 form-group">
                                            <select class="form-control custom-select" name="projectClient" [(ngModel)]="input.value"  (change)="onClientChange($event)">
                                              <option [ngValue]="null" disabled>Choose a client</option>
                                              <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
                                            </select>
                                            <div class="invalid-feedback">Select a client</div>
                                          </div>
                                        </ng-container>
                                    </div>
                           <!--<div class="row" style="margin-top:20px;">
                                <div class="col-md-4">
                                    <label>Client</label>
                                </div>
                                <div class="col-md-8">
                                    <select class="form-control" name="projectClient" [(ngModel)]="modelObject.client.id" #projectClient="ngModel" (change)="onClientChange($event)">
                                      <option [ngValue]="null" disabled>Choose a client</option>
                                      <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
                                    </select>
                                    <div *ngIf="projectClient.invalid && (projectClient.dirty || projectClient.touched)"
                                        class="alert alert-danger">
                                        <div [hidden]="!projectClient.errors.required">
                                            You must select client
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="margin-top:20px;">
                                <div class="col-md-4">
                                    <label>Code</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" placeholder="Code Project" class="form-control" name="projectCode" #projectCode="ngModel" [(ngModel)]="modelObject.code" />
                                    <div *ngIf="projectCode.errors && (projectCode.dirty || projectCode.touched)"
                                        class="alert alert-danger">
                                        <div [hidden]="!projectCode.errors.required">
                                            Code is required
                                        </div>
                                    </div>
                                </div>
                            </div>-->
                                <!-- footer-->
                                <div class="modal-footer ">
                                  <button class="btn btn-primary clickable hand" id="submit" type="submit">{{'save'|translate}}</button>
                                </div>
                            </form>
                              </div>
                            </div>
                        </div>
                        <article *ngIf="this.log">
                            {{logContent}}
                        </article>
                     </div>
                </div>
         </div>`

})
export class CreateObjectDialogComponent implements OnInit,OnChanges {

    private hide = true;
    @Output() NewObjectEvent: EventEmitter<string> = new EventEmitter();
    @Input() modelObject: (Project|Client|Ftp|ServerConfig|SmsConfig|FacebookAPIConfig|MailConfig); // = new Project('');
    private newForm:FormGroup;
    private objectCreated= false;
    private errorCreatingObject = false;

    // private isWebProject = false;

    @Input() wizardTitle;
    @Input() formModel:FormModel;

    @Input() logContent:string;

    private log = false;

    clients: Client[];

    errorMessage: string;



    constructor(private _projectService: ProjectService) {
    }

    ngOnInit() {
        this.getClients();
    }

    private genarateFormGroup() {
      this.newForm = new FormGroup({
      });

      console.log(this.modelObject);

      for(const input of this.formModel.inputs) {
        if(Reflect.has(this.modelObject,input.label.get('en').toLowerCase())) {
          this.newForm.addControl(input.name.get('en'), new FormControl(Reflect.get(this.modelObject,input.label.get('en').toLowerCase()), [Validators.required]));
        }
      }
    }

    private getModelProperty(inputProperty:string) {
      return Reflect.get(this.modelObject,inputProperty);
    }

    onClientSelected(clientId) {
        let c:Client = null;
        for (const client of this.clients) {
            if (client.id === clientId) {
                c = client;
                break;
            }
        }

        if (c != null) {
          if (this.modelObject instanceof Project) {
            this.modelObject.client = c;
          }
        }
    }


  ngOnChanges(changes: SimpleChanges) {
    console.log('ngOnChange called');
    this.genarateFormGroup();
  }

  setAsLog() {
      this.log=!this.log;
  }

  createModelObject() {

      if(this.modelObject instanceof Project) {
        console.log('instance of project');
        for(const input of this.formModel.inputs) {
          switch(input.name.get('en')) {
            case 'ProjectName':this.modelObject.name = input.value;break;
            case 'ProjectClient':this.modelObject.client.id = Number(input.value);break;
            case 'ProjectCode': this.modelObject.code = input.value;break;
            // case 'WebProject': this.modelObject.webProject = this.isWebProject;break;
          }
        }
        this._projectService.createProject(this.modelObject, -1)
          .subscribe(data => {
              this.NewObjectEvent.emit('project');
              this.objectCreated = true;
            },
            error => {
              console.log('Error Add project');
              this.errorCreatingObject = true;
            });

        this.toggleDialog();
      } else if(this.modelObject instanceof Client) {

        for(const input of this.formModel.inputs) {
          switch(input.label.get('en')) {
            case 'Name':this.modelObject.name = input.value;break;
            case 'Username':this.modelObject.username = input.value;break;
            case 'Password': this.modelObject.password = input.value;break;
          }
        }
        this._projectService.createClient(this.modelObject)
          .subscribe(data => {
              console.log(data);
              this.objectCreated=true;
              this.NewObjectEvent.emit('client');
              this.getClients();
            },
            error => {console.log('Error create client');this.errorCreatingObject=true;});
        this.toggleDialog();
      } else if (this.modelObject instanceof Ftp) {
        for(const input of this.formModel.inputs) {
          switch(input.label.get('en')) {
            case 'Server IP':this.modelObject.FtpServerIP = input.value;break;
            case 'Port':this.modelObject.Port = input.value;break;
            case 'Username': this.modelObject.Username = input.value;break;
            case 'Password': this.modelObject.Password = input.value;break;
          }
        }
        console.log(this.modelObject);
        this._projectService.configureFtp(this.modelObject)
          .subscribe(data => {
              console.log(data);
              this.objectCreated=true;
              this.NewObjectEvent.emit('ftp');
            },
            error => {console.log('Error create client');this.errorCreatingObject=true;});
        this.toggleDialog();
      } else if (this.modelObject instanceof ServerConfig) {
        for(const input of this.formModel.inputs) {
          switch(input.label.get('en')) {
            case 'Server IP':this.modelObject.ipAddress = input.value;break;
            case 'Port':this.modelObject.port = input.value;break;
          }
        }
        console.log(this.modelObject);
        this._projectService.configureServer(this.modelObject)
          .subscribe(data => {
              console.log(data);
              this.objectCreated=true;
              this.NewObjectEvent.emit('serverConfig');
            },
            error => {console.log('Error create client');this.errorCreatingObject=true;});
        this.toggleDialog();
      } else if (this.modelObject instanceof SmsConfig) {
        for(const input of this.formModel.inputs) {
          switch(input.label.get('en')) {
            case 'Account SID':this.modelObject.accountSid = input.value;break;
            case 'Authentication Token':this.modelObject.authToken = input.value;break;
            case 'From Number':this.modelObject.fromNumber = input.value;break;
            case 'Test Number':this.modelObject.testNumber = input.value;break;
            case 'Maximum Share':this.modelObject.maxShare = input.value;break;
            case 'Expiry Date':this.modelObject.until = input.value;break;
          }
        }
        console.log(this.modelObject);
        this._projectService.configureTwilio(this.modelObject)
          .subscribe(data => {
              console.log(data);
              this.objectCreated=true;
              this.NewObjectEvent.emit('smsConfig');
            },
            error => {console.log('Error create client');this.errorCreatingObject=true;});
        this.toggleDialog();
      } else if (this.modelObject instanceof FacebookAPIConfig) {
        for(const input of this.formModel.inputs) {
          switch(input.label.get('en')) {
            case 'API Key':this.modelObject.ApiKey = input.value;break;
          }
        }
        console.log(this.modelObject);
        this._projectService.configureFacebookAPI(this.modelObject)
          .subscribe(data => {
              console.log(data);
              this.objectCreated=true;
              this.NewObjectEvent.emit('facebookConfig');
            },
            error => {console.log('Error create client');this.errorCreatingObject=true;});
        this.toggleDialog();
      } else if(this.modelObject instanceof TwitterAPIConfig) {
          for(const input of this.formModel.inputs) {
              switch(input.label.get('en')) {
                  case 'Consumer Key':this.modelObject.consumerKey = input.value;break;
                  case 'Consumer Secret Key':this.modelObject.consumerSecretKey = input.value;break;
              }
          }
          console.log(this.modelObject);
          this._projectService.configureTwitterAPI(this.modelObject)
              .subscribe(data => {
                      console.log(data);
                      this.objectCreated=true;
                      this.NewObjectEvent.emit('twitterConfig');
                  },
                  error => {console.log('Error create client');this.errorCreatingObject=true;});
          this.toggleDialog();
      }

    }

    getClients() {
        this._projectService.getClients()
            .then(
            clients => {
                this.clients = clients;
                console.log(this.clients);
            },
            error => this.errorMessage = <any>error);
    }

    public toggleDialog() {
        if(this.log) {
            this.log = false;
        }
        this.modelObject = null;
        this.newForm.reset();
        this.hide = !this.hide;
    }


    onClientChange($event:any) {
      if (this.modelObject instanceof Project) {
        this.modelObject.client.name = $event.target.value;
      }
    }

  onClose() {
    this.errorCreatingObject=false;
    this.objectCreated = false;
  }

  validate(value: string,field:string):string {
      switch(field) {
        case 'Name':if(value==null || value.length===0) {return 'form-control invalid-feedback';}return 'form-control valid-feedback';break;
        case 'Username':if(value==null ||value.length===0) {return 'form-control invalid-feedback';} return 'form-control valid-feedback';break;
        case 'Password': if(value==null ||value.length===0) {return 'form-control invalid-feedback';} return 'form-control valid-feedback'; break;
        case 'Code':if(value==null || value.length===0) {return 'form-control invalid-feedback';} return 'form-control valid-feedback';break;
      }
  }


  /*  webProjectCheck() {
        this.isWebProject = !this.isWebProject;
    }*/
}
